module.exports = __webpack_public_path__ + "img/token.22f2aab5.png";